var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-row', [_vm.maintenanceDetailData.trigger === 'CALENDAR' ? [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Due Maintenance Date"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-type": "DD-MM-YYYY",
      "format": "DD MMM YYYY",
      "type": "date",
      "disabled": "",
      "placeholder": "Select date"
    },
    model: {
      value: _vm.localForm.possibleMaintenanceDate,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "possibleMaintenanceDate", $$v);
      },
      expression: "localForm.possibleMaintenanceDate"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Maintenance Date *"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-type": "DD-MM-YYYY",
      "format": "DD MMM YYYY",
      "type": "date",
      "placeholder": "Select date"
    },
    model: {
      value: _vm.localForm.maintenanceDate,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "maintenanceDate", $$v);
      },
      expression: "localForm.maintenanceDate"
    }
  })], 1)], 1)] : [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Maintenance Date *"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "value-type": "DD-MM-YYYY",
      "format": "DD MMM YYYY",
      "type": "date",
      "placeholder": "Select date"
    },
    model: {
      value: _vm.localForm.maintenanceDate,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "maintenanceDate", $$v);
      },
      expression: "localForm.maintenanceDate"
    }
  })], 1)], 1)], _vm.maintenanceDetailData.trigger === 'COUNTER' ? [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Due Maintenance Hours"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "disabled": "",
      "placeholder": "0",
      "type": "number"
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v("Hours")])], 1)], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Maintenance Hours *"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "0",
      "type": "number"
    },
    model: {
      value: _vm.localForm.maintenanceRunningHours,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "maintenanceRunningHours", $$v);
      },
      expression: "localForm.maintenanceRunningHours"
    }
  }), _c('b-input-group-append', [_c('b-input-group-text', [_vm._v("Hours")])], 1)], 1)], 1)], 1)] : _vm._e(), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Cost"
    }
  }, [_c('InputCurrency', {
    attrs: {
      "placeholder": "0"
    },
    model: {
      value: _vm.localForm.cost,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "cost", $$v);
      },
      expression: "localForm.cost"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "File Maintenance"
    }
  }, [_c('b-form-file', {
    attrs: {
      "placeholder": "Choose a file",
      "name": "select-file-maintenance"
    },
    on: {
      "change": function change($event) {
        return _vm.$emit('uploadFile', $event);
      }
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" File Type * : "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v(".jpg | .jpeg | .png | .xlx | .xlxs | .doc | .docs | .pdf")]), _c('br'), _vm._v(" File Capacity * : "), _c('b-badge', {
    attrs: {
      "variant": "warning"
    }
  }, [_vm._v("2 MB / File")])], 1)], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Notes *"
    }
  }, [_c('wysiwyg', {
    model: {
      value: _vm.localForm.notes,
      callback: function callback($$v) {
        _vm.$set(_vm.localForm, "notes", $$v);
      },
      expression: "localForm.notes"
    }
  }), _c('small', [_vm._v("Sign * : "), _c('strong', [_vm._v("Mandatory (Must Fill)")])])], 1)], 1), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-outline-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.onAction('VIEW_DETAIL');
      }
    }
  }, [_vm._v("Cancel")])]), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "md": "6"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary w-100",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('submitForm');
      }
    }
  }, [_vm._v("Submit")])])], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }